import { Materia } from "./materia";

export class Tema {
    id: number;
    nome: string;
    urlCurta: string;
    obs: string;
    materias?:Materia[]
}